import MobileMenu from './MobileMenu'

export default MobileMenu



// WEBPACK FOOTER //
// ./src/app/modules/MobileMenu/index.js